import { installSteps } from '@/mocks/downloadData';

export default function InstallSteps() {
  return (
    <section id="install" className="w-full bg-background-100 px-4 md:px-8 py-14 md:py-20 scroll-mt-20">
      <div className="max-w-6xl mx-auto">
        <div className="mb-8">
          <span className="inline-flex items-center gap-1.5 text-primary-600 text-xs font-medium tracking-wide">
            <i className="ri-guide-line"></i>
            GUIDE
          </span>
          <h2 className="mt-2 font-heading text-3xl md:text-4xl text-foreground-950 tracking-wide">
            四步完成安装
          </h2>
          <p className="mt-3 max-w-2xl text-foreground-600 text-sm md:text-base leading-relaxed">
            整个过程通常不超过一分钟。按下面的顺序操作，遇到系统拦截时按提示允许即可。
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {installSteps.map((step, idx) => (
            <div key={step.step} className="relative rounded-lg border border-background-200 bg-background-50 p-5">
              <div className="flex items-center justify-between">
                <span className="font-heading text-4xl text-background-300">{step.step}</span>
                <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-800 text-xl">
                  <i className={step.icon}></i>
                </span>
              </div>
              <h3 className="mt-3 text-foreground-950 text-base font-medium">{step.title}</h3>
              <p className="mt-2 text-foreground-600 text-sm leading-relaxed">{step.desc}</p>
              {idx < installSteps.length - 1 && (
                <i className="hidden lg:block ri-arrow-right-line absolute -right-3 top-1/2 -translate-y-1/2 text-background-400 text-lg"></i>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}